export default __webpack_public_path__ + "static/media/girl.5ce8864f.png";